import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {resolveAppointmentVoucher} from '../../../services/appointmentVoucher.service';
import {readableApiError} from '../../../helpers/apiError';
import {appointmentVoucherLabel} from './appointmentDeposit';

export default function AppointmentVoucherCode({formik}) {
  const {t} = useTranslation();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [voucher, setVoucher] = useState(null);
  const [loading, setLoading] = useState(false);
  const requestVersion = useRef(0);
  const {values, setFieldValue} = formik;
  const context = JSON.stringify([values.id, values.client_id, values.service_id,
    values.totaldeposit, values.addonservices, values.addanotherservices, values.deposit_payment_by]);

  useEffect(() => {
    requestVersion.current += 1;
    setVoucher(null); setError(''); setLoading(false);
    setFieldValue('voucher_to_id', '', false);
    setFieldValue('voucher_code', '', false);
    return () => {requestVersion.current += 1;};
  }, [context, setFieldValue]);

  const changeCode = event => {
    requestVersion.current += 1;
    setCode(event.target.value); setVoucher(null); setError(''); setLoading(false);
    setFieldValue('voucher_to_id', '', false);
    setFieldValue('voucher_code', '', false);
  };
  const apply = async () => {
    const enteredCode = code.trim();
    if (!enteredCode) {setError(t('Enter a voucher code.')); return;}
    const version = ++requestVersion.current;
    setLoading(true); setError(''); setVoucher(null);
    setFieldValue('voucher_to_id', '', false);
    setFieldValue('voucher_code', '', false);
    try {
      const resolved = await resolveAppointmentVoucher({
        voucher_code: enteredCode,
        client_id: values.client_id,
        service_id: values.service_id,
        totaldeposit: values.totaldeposit,
        ...(values.id ? {appointment_id: values.id} : {}),
      });
      if (version !== requestVersion.current) return;
      setVoucher(resolved);
      setFieldValue('voucher_to_id', resolved.voucher_to_id, false);
      setFieldValue('voucher_code', resolved.code, false);
    } catch (failure) {
      if (version !== requestVersion.current) return;
      setError(readableApiError(failure?.response?.data, t('Unable to verify this voucher. Please try again.')));
    } finally {
      if (version === requestVersion.current) setLoading(false);
    }
  };
  return <>
    <label htmlFor="appointmentForm-voucher" className="text-dark fw-semibold">{t('Voucher code')}</label>
    <div className="d-flex gap-2">
      <input id="appointmentForm-voucher" className="form-control" value={code} placeholder={t('e.g. GIFT-4821')} onChange={changeCode}/>
      <button type="button" className="btn btn-primary" disabled={loading} onClick={apply}>{t(loading ? 'Checking…' : 'Apply')}</button>
    </div>
    {voucher ? <p className="text-success mt-1 mb-0">{appointmentVoucherLabel(voucher)}</p> : null}
    {error ? <p className="text-danger mt-1 mb-0" role="alert">{error}</p> : null}
  </>;
}
AppointmentVoucherCode.propTypes = {formik: PropTypes.shape({values: PropTypes.object.isRequired, setFieldValue: PropTypes.func.isRequired}).isRequired};
